// Align with backend enum: High=0, Medium=1, Low=2, None=3
export var PriorityEnum;
(function (PriorityEnum) {
    PriorityEnum[PriorityEnum["High"] = 0] = "High";
    PriorityEnum[PriorityEnum["Medium"] = 1] = "Medium";
    PriorityEnum[PriorityEnum["Low"] = 2] = "Low";
    PriorityEnum[PriorityEnum["None"] = 3] = "None";
})(PriorityEnum || (PriorityEnum = {}));
export const PriorityEnumDisplay = {
    [PriorityEnum.High]: 'Most Important',
    [PriorityEnum.Medium]: 'Medium',
    [PriorityEnum.Low]: 'Low',
    [PriorityEnum.None]: 'None'
};
